export const ImageUrl = (url) => {
  const organization = JSON.parse(
    localStorage.getItem('currentOrganization')
  )?.created_by_platform;
  const ImsUrl = process.env.REACT_APP_AWS_S3_IMS_BUCKET_URL;
  const BooksUrl = process.env.REACT_APP_AWS_S3_BOOKS_BUCKET_URL;

  return organization === 'ims' ? `${ImsUrl}/${url}` : `${BooksUrl}/${url}`;
};
